import type React from 'react';
import { useEffect } from 'react';

const BugHerd : React.FC = () => {
  useEffect(() => {
    const script = document.createElement('script');
    if (process.env.REACT_APP_BUGHERD_API_KEY) {
      script.src = `https://www.bugherd.com/sidebarv2.js?apikey=${process.env.REACT_APP_BUGHERD_API_KEY}`;
    }
    script.async = true;
    document.head.appendChild(script);

    // Cleanup function: remove the script when the component is unmounted.
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return null; // Component doesn't render anything.
};

export default BugHerd;
